<template>
  <a-modal
    v-model:visible="visible"
    title="添加角色"
    :mask-closable="false"
    :get-container="modalContainer"
    :after-close="modalClosed"
  >
    <template #footer>
      <a-button :disabled="disabled" @click="visible = false">取消</a-button>
      <a-button :disabled="disabled" type="primary" @click="doSubmit"
        >确定</a-button
      >
    </template>
    <a-form :label-col="{ span: 4 }">
      <a-form-item v-bind="validateInfos.name" label="名称">
        <a-input
          v-model:value="roleVo.name"
          placeholder="角色名称"
          allow-clear
          :maxlength="16"
        ></a-input>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea
          v-model:value="roleVo.remark"
          placeholder="角色描述"
          :maxlength="64"
          allow-clear
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { onMounted, ref, toRefs } from "vue";
import useSysRole from "@/hooks/system/useSysRole";
import useValidateRules from "@/hooks/useValidateRules";
import useMessage from "@/hooks/useMessage";
import { Form } from "ant-design-vue";
import { detail, update } from "@/api/sys/sysRoleApi";
const useForm = Form.useForm;
export default {
  name: "Edit",
  emits: ["close"],
  props: ["modalContainer", "id"],
  setup(props, { emit }) {
    let refresh = false;
    const visible = ref(true);
    const disabled = ref(false);
    const { roleVo } = useSysRole();
    const { sysRoleRules } = useValidateRules();
    const { validateInfos, validate } = useForm(roleVo, sysRoleRules);
    const { showErr, showLoading, closeLoading, showConfirm, showTipMessage } =
      useMessage();
    const modalClosed = () => {
      emit("close", refresh);
    };
    const doSubmit = () => {
      validate().then(async () => {
        let r = await showConfirm("确认修改角色信息?");
        if (r) {
          disabled.value = true;
          await showLoading();
          try {
            await update(props.id, roleVo);
            await closeLoading();
            await showTipMessage("修改成功");
            refresh = true;
            visible.value = false;
          } catch (e) {
            await closeLoading();
            await showErr(e);
            disabled.value = false;
          }
        }
      });
    };
    onMounted(async () => {
      try {
        let { data } = await detail(props.id);
        roleVo.name = data.name;
        roleVo.remark = data.remark;
      } catch (e) {
        await showErr(e);
      }
    });
    return {
      ...toRefs(props),
      visible,
      disabled,
      modalClosed,
      roleVo,
      validateInfos,
      doSubmit,
    };
  },
};
</script>

<style scoped></style>
